import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLoaderData } from 'react-router-dom';
import hubDaive from './assets/hubdaive.png'
import MenuLateral from './components/MenuLateral.jsx';
import MenuProfile from './components/MenuProfile.jsx';
import CustomText from './components/CustomText.jsx'; 

function NewsPage() {
  const navigate = useNavigate();
  
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  const newsPerPage = 8;
  const indexOfLastNews = currentPage * newsPerPage;
  const indexOfFirstNews = indexOfLastNews - newsPerPage;
  const isSearching = searchResults.length > 0;
  const activeNews = isSearching ? searchResults : news;
  // const currentNews = isSearching
  //   ? activeNews.slice(0, newsPerPage)
  //   : activeNews.slice(indexOfFirstNews, indexOfLastNews);
  const totalPages = Math.ceil(news.length / newsPerPage);
  const currentNews = activeNews.slice(indexOfFirstNews, indexOfLastNews);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
  
  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await fetch(`https://hubdaive.com.br/api/verify-token`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

        if (!response.ok) {
          throw new Error('Token verification failed');
        }
      } catch (error) {
        localStorage.removeItem('token');
        navigate('/');
      }
    };

    verifyToken();
  }, [navigate]);

  useEffect(() => {
    const fetchNews = async () => {
      setLoading(true);
      const token = localStorage.getItem('token');
      try {
        const response = await fetch("https://hubdaive.com.br/api/news", {
          headers: { 
            'Authorization': `Bearer ${token}` 
          }
        });
        const data = await response.json();
        
        if (data.error) {
          console.error(data.error);
        } else {
          setNews(data);
        }
      } catch (err) {
        console.error("Erro ao conectar com a rota de notícias");
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  const handleSearch = async () => {
    setCurrentPage(1);
    if (!searchQuery.trim()) {
      setSearchResults([]);
      return;
    }

    setSearching(true);
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`https://hubdaive.com.br/api/news/search?q=${encodeURIComponent(searchQuery)}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      setSearchResults(data);
    } catch (err) {
      console.error("Erro na busca");
    } finally {
      setSearching(false);
    }
  };

  if (loading) {
        return (
            <div style={{
            position: 'fixed', inset: 0, backgroundColor: '#000',
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center', zIndex: 9999
          }}>
            <div style={{ position: 'relative', width: '100px', height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ width: '12px', height: '12px', backgroundColor: '#007AFF', borderRadius: '50%', zIndex: 2 }} />
              <div className="ripple" style={{ animationDelay: '0s' }} />
              <div className="ripple" style={{ animationDelay: '1s' }} />
              <div className="ripple" style={{ animationDelay: '2s' }} />
            </div>
            <h2 style={{ color: '#fff', marginTop: '40px', fontWeight: '300', fontFamily: 'sans-serif', letterSpacing: '2px', opacity: 0.8 }}>
              Indo às profundezas...
            </h2>
            <style>{`
              .ripple {
                position: absolute;
                border: 2px solid #007AFF;
                opacity: 0;
                border-radius: 50%;
                width: 10px;
                height: 10px;
                animation: ripple-effect 3s linear infinite;
              }
              @keyframes ripple-effect {
                0% { width: 10px; height: 10px; opacity: 0.8; }
                100% { width: 250px; height: 250px; opacity: 0; border-width: 1px; }
              }
            `}</style>
          </div>
      );
    }


  return (
  <div style={{
    position:'relative',
    minHeight: '100vh',
    maxWidth:'100vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'black', 
    fontFamily: 'Helvetica'
  }}>

  <img className="news-logo"
        src={hubDaive}
        alt="logo"
        style={{ position: 'absolute',
        top: '2.8%',          
        left: '4%',         
        width: '10vw',
        height: 'auto' }} 
      />
          
    <CustomText
      placeholder="Pesquisar notícias..."
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      onKeyDown={(e) => {if (e.key == 'Enter') handleSearch()}}
      />
      {searching && (
        <p style={{ color: '#007AFF', fontSize: '1.5vh', marginTop: '1vh' }}>Buscando...</p>
      )}
    

    {/* O GRID 3x3 */}
    <main className="news-grid"
    key={currentPage}
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gridTemplateRows: 'repeat(4, 1fr)',
      gap: '20px',
      width: '90vw',
      // height: '80vh',
      marginTop:'10vh' ,
      maxWidth: '100vw',
      animation: 'fadeInUp 0.8s ease-out'
    }}>
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
          
        /* MOBILE */
          @media (max-width: 767px) {
            .news-grid {
              grid-template-columns: 1fr !important;
              width: 90vw !important;
              margin-top: 5vh !important;
            }
            .news-card {
              flex-direction: column !important;
              margin-left: 0 !important;
            }
            .news-thumbnail {
              width: 100% !important;
              height: 25vw !important;
            }
            .news-logo {
              display:none ;
            }
            .pagination {
              gap: 8px !important;
            }
            .pagination button {
              margin-top: 3vh !important;
              margin-bottom : 1vh !important;
              font-size: 14px !important;
            }
            .news-spacing{
              margin-top: 3vh !important;
            }
        }
    `}</style>
      
      {currentNews.map((item, index) => (
        <a className="news-card"
          href={item.link} 
          key={index}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'flex',
            flexDirection: 'row',
            padding: '15px',
            marginLeft:'2vw',
            backgroundColor: '#1a1a1a',
            border: '1px solid #333',
            borderRadius: '12px',
            textDecoration: 'none',
            color: 'inherit',
            overflow: 'hidden'
          }}
        >
          {/* Thumbnail à esquerda */}
        {item.thumbnail && (
          <div className="news-thumbnail" style={{ width: '20vw', height: '20vh', flexShrink: 0, backgroundColor: '#333', borderRadius: '8px', overflow: 'hidden' }}>
            <img src={item.thumbnail} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
        )}

        {/* Conteúdo à direita */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <div>
            <div className="news-spacing" style={{ fontSize: '2vh', color: '#007AFF', fontWeight: 'bold', marginLeft: '1vw', marginBottom: '1vh' }}>
              {item.source}
            </div>
            <div style={{ 
              color: 'white', fontWeight: 'bold', fontSize: '1.7vh', marginLeft: '1vw',
              display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' 
            }}>
              {item.title}
            </div>
          </div>
          <span style={{ fontSize: '1.3vh', color: 'white', marginTop: '2vh', marginLeft: '1vw', }}>{item.date}</span>
        </div>
      </a>
    ))}
  </main>

    {/* CONTROLES DE PAGINAÇÃO */}
    <div className="pagination" style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
      <button 
        disabled={currentPage === 1}
        onClick={() => paginate(currentPage - 1)}
        style={{
          padding: '10px 20px',
          marginTop:'6vh',
          marginBottom:'5vh',
          marginRight:'10vw',
          backgroundColor: currentPage === 1 ? '#333' : '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          fontSize: '1.8vh',
          cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
        }}
      >
        Anterior
      </button>

      <button 
        disabled={currentPage === totalPages}
        onClick={() => paginate(currentPage + 1)}
        style={{
          padding: '10px 20px',
          marginTop:'6vh',
          marginBottom:'5vh',
          backgroundColor: currentPage === totalPages ? '#333' : '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          fontSize: '1.8vh',
          cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
        }}
      >
        Próximo
      </button>
    </div>
  </div>
  )
}

export default NewsPage;